import React from 'react';

import { Button } from '../Button';
import { GeneralTime } from '../constants';

interface Props {
  backgroundColor?: string;
  dayId: number;
  index: number;
  label?: string;
  time: GeneralTime;
  isDaySelected(index: number, time: GeneralTime): boolean;
  toggleDay(index: number, time: GeneralTime): void;
}

export const Day = ({ backgroundColor, dayId, index, label, time, isDaySelected, toggleDay }: Props): JSX.Element => {
  const handleDayClick = (): void => toggleDay(index, time);
  const selected = (): boolean => isDaySelected(index, time);

  return (
    <div className='inline-block h-14 align-middle'>
      <Button
        className={`${
          (selected() && backgroundColor) || 'bg-neutral-200'
        } w-9 h-9 sm:w-10 sm:h-10 text-center text-sm font-semibold rounded-full`}
        name={`day-${dayId}-${time}`}
        onClick={handleDayClick}
      >
        <span className='block leading-9 sm:leading-10'>{label}</span>
      </Button>
    </div>
  );
};
